/** Web / non-Android: no-op. */
export async function runAndroidNotificationsOnboardingOnce(): Promise<void> {
  return;
}

/** Web / non-Android: полноэкранных уведомлений о звонке здесь нет. */
export async function maybeNudgeFullScreenIntent(): Promise<void> {
  return;
}

/** Web / non-Android: отмечать нечего. */
export async function markMissedCallForNudge(): Promise<void> {
  return;
}
